export default __webpack_public_path__ + "static/media/icon-s-key.3726875b.svg";